module.exports = __webpack_public_path__ + "media/images/flags/ye-09032b32c871d636121aaf0b20bdc66c.svg";